import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'

export interface RequisitionOffer {
  id: number
  uuid: string
  currencyAmount: number
  exchangeRate: number
  status: string
  discount: { currentUser: { rate: number | null } } | null
  currency: { titleFa: string }
  country: { title: { fa: string } }
  transferMethods: Array<{ id: string; title: string; label: string }>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  bankAccountCountries?: any
  createdAt: string
  expiresAt: string
  requisition: {
    id: number
    uuid: string
    code: string
    currencyAmount: number
    type: 'BUY' | 'SELL'
    availableForOffer: boolean
  }
}

export function getRequisitionOffersAction(
  requisitionId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filters: Record<string, any> = {}
): Promise<ApiPaginationResponse<RequisitionOffer[]>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(key, String(value))
    }
  })

  const url = `/requisitions/${requisitionId}/offers?${params.toString()}`

  return api.get<ApiPaginationResponse<RequisitionOffer[]>>(url)
}
